import { IRoomValidationStatusCode } from "@backend/src/schemas";

export const ROOM_VALIDATION_STATUS_CODES = [
  "APPROVED",
  "APPROVED_WITH_DEVIATIONS",
  "NEEDS_CHECK",
] as const;

export const ROOM_VALIDATION_STATUS_LABELS: Record<IRoomValidationStatusCode, string> = {
  APPROVED: "Godkjent",
  APPROVED_WITH_DEVIATIONS: "Godkjent med avvik",
  NEEDS_CHECK: "Må kontrolleres",
};
